import React from "react";

const PortalSelector = ({ portal, setPortal, superAdmin, role, disabled = false }) => {
    if (!(superAdmin === '1' || role === 'i' || role === 'c')) return null;

    const handleChange = (e) => {
        const selected = e.target.value;
        localStorage.setItem('portal', selected);
        setPortal(selected);
    };

    return (
        <div className='flex justify-start items-center w-fit bg-transparent py-2 px-4 ml-2 rounded-sm'>
            <p className="text-grey">Portal:</p>
            <select
                disabled={disabled}
                className="text-mainBlue border border-offWhite rounded-sm bg-transparent px-2 py-1"
                onChange={handleChange}
                value={portal}
            >
                <option value="dgg">DGG</option>
                <option value="ruv">R+V</option>
            </select>
        </div>
    );
};

export default PortalSelector;
